import { BottomSheet } from '@s4l/ds'
import React, { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import ButtonLink from 'src/comps/Atom/Buttons/ButtonLink'
import { PropertyFacilities } from 'src/types/property'
import { getUniqueCategories } from '../Facilities/utils'
import { FacilitiesList } from './FacilitiesList'
import styles from './styles.module.css'

interface MappedClusteredFacilities {
  code: number
  description: string
  facilities: PropertyFacilities[]
}

interface IFacilitiesV2Props {
  facilities?: PropertyFacilities[]
  clusteredFacilities?: MappedClusteredFacilities[]
  showAllFacilities?: boolean
  hideCategoriesIcons?: boolean
  showFreeTag?: boolean
}

const FEATURED_CATEGORIES_NUMBER = 2

export function FacilitiesV2(props: Readonly<IFacilitiesV2Props>) {
  const {
    facilities = [],
    clusteredFacilities = [],
    showAllFacilities = false,
    hideCategoriesIcons = false,
    showFreeTag = false,
  } = props
  const intl = useIntl()
  const [isOpen, setIsOpen] = useState(false)

  const { categories, facilitiesList } = useMemo(() => {
    if (clusteredFacilities.length > 0) {
      return {
        categories: clusteredFacilities
          .filter(cluster => cluster.facilities.length > 0)
          .map(cluster => cluster.code),
        facilitiesList: clusteredFacilities
          .filter(cluster => cluster.facilities.length > 0)
          .flatMap(cluster =>
            cluster.facilities.map(facility => ({
              ...facility,
              categoryCode: cluster.code,
              categoryName: cluster.description,
            }))
          ),
      }
    }
    return {
      categories: getUniqueCategories(facilities),
      facilitiesList: facilities,
    }
  }, [facilities, clusteredFacilities])

  const featuredCategories = showAllFacilities
    ? categories
    : categories.slice(0, FEATURED_CATEGORIES_NUMBER)

  return (
    <div>
      <FacilitiesList
        facilities={facilitiesList}
        categories={featuredCategories}
        hideTitleIcon={hideCategoriesIcons}
        showFreeTag={showFreeTag}
      />

      {!showAllFacilities && (
        <>
          <ButtonLink
            text="global.show-more"
            className={styles.showMoreBase}
            onClick={() => setIsOpen(true)}
          />
          <BottomSheet open={isOpen} onClose={() => setIsOpen(false)}>
            <BottomSheet.Content
              title={intl.formatMessage({ id: 'global.facilities' })}
              scroll
              modalOnDesktop
            >
              <FacilitiesList
                facilities={facilitiesList}
                categories={categories}
                hideTitleIcon={hideCategoriesIcons}
                showFreeTag={showFreeTag}
              />
            </BottomSheet.Content>
          </BottomSheet>
        </>
      )}
    </div>
  )
}
